import { Component, OnInit, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CellClickedEvent, GridApi } from 'ag-grid-community';
import { CustomgridModel, CustomgridParam, CustomgridSQL, CustomgridXml, QResult } from '../../../../../models';
import { ELearningStageModel } from '../../../../../models/formation';
import { CoreService, HttpService } from '../../../../../services';
import { ToastService } from '../../../../../toast';
import { StageService } from '../../services/stage-modal.service';



@Component({
  selector: 'queoval-stage-digital-learning',
  templateUrl: './digital-learning-extranet.component.html',
  styleUrls: ['./digital-learning-extranet.component.css']
})

export class DigitalLearningExtranetComponent implements OnInit {
  constructor(
    public service: StageService,
    private http: HttpService,
    public indParam: CoreService,
    private toast: ToastService,
    private modalService: NgbModal
  ) { }

  public customgridParam: CustomgridModel;
  private gridApi: GridApi;

  public ngOnInit(): void {
    this.getGrid();
  }


  public OpenModal(content: any) {
    this.modalService.open(content, { size: 'q-xxl', centered: true, windowClass: 'qmodalover modal-cycleDigitalLearning' }).result.then((result) => {
      switch (result) {
        //  case 'SAVE':  break;
        //  case 'CANCEL':  break;
      }
    });
  }

  public getGrid(): void {
    this.customgridParam = new CustomgridModel();
    this.customgridParam.cgParameters = new CustomgridParam();
    this.customgridParam.cgParameters.isDataLoaded = false;
    // Récupération de la grid
    this.http.getHttp<QResult<ELearningStageModel>>(`${this.indParam.AppParams.apiUrl}api/Stage/Extranet/ELearning/GET_GRID_ELEARNING/${this.service.Stage.Ident}`).subscribe((result: QResult<ELearningStageModel>) => {
     // this.customgridParam = new CustomgridModel();
      this.customgridParam.GridXml = new CustomgridXml();
      this.customgridParam.GridXml.rowData = new CustomgridSQL();
    //  this.customgridParam.cgParameters = new CustomgridParam();
      this.customgridParam.cgParameters.FileName = result.Value.GridName;
      this.customgridParam.GridXml.columnDefs = result.Value.ColumnDefs ? result.Value.ColumnDefs : [];
      this.customgridParam.GridXml.rowData.data = JSON.stringify(result.Value.RowData);
      this.customgridParam.GridXml.adaptHeight = true;
      this.customgridParam.cgParameters.isDataLoaded = true;
      this.customgridParam.GridXml.rowSelection = 'multiple';

    });
  }

}
